// extracted by mini-css-extract-plugin
export default {"image":"VolunteerInfo_image__ZenJn","image_plug":"VolunteerInfo_image_plug__b06GW"};